// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1PE56","containerItemsCenter":"Skeleton_containerItemsCenter__tw372"};